export default {
      id: "accessability-symbols-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite.svg#accessability-symbols",
      toString: function () {
        return this.url;
      }
    }